// This file was automatically generated by graphql-code-generator
// Changes to this file will be lost


import * as Types from '../../../engine/apis/magento2/types.generated.d';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetOrderQueryVariables = Types.Exact<{
  orderNumber: Types.Scalars['String'];
}>;


export type GetOrderQuery = { __typename?: 'Query', customer?: { __typename?: 'Customer', orders?: { __typename?: 'CustomerOrders', total_count?: number | null, items: Array<{ __typename?: 'CustomerOrder', id: string, number: string, order_date: string, status: string, shipping_method?: string | null, shipping_address?: { __typename?: 'OrderAddress', firstname: string, lastname: string, company?: string | null, street: Array<string | null>, city: string, region?: string | null, region_id?: string | null, postcode?: string | null, country_code?: Types.CountryCodeEnum | null, telephone?: string | null } | null, billing_address?: { __typename?: 'OrderAddress', firstname: string, lastname: string, company?: string | null, street: Array<string | null>, city: string, region?: string | null, region_id?: string | null, postcode?: string | null, country_code?: Types.CountryCodeEnum | null, telephone?: string | null } | null, total?: { __typename?: 'OrderTotal', grand_total: { __typename?: 'Money', value?: number | null, currency?: Types.CurrencyEnum | null }, subtotal: { __typename?: 'Money', value?: number | null, currency?: Types.CurrencyEnum | null }, total_shipping: { __typename?: 'Money', value?: number | null, currency?: Types.CurrencyEnum | null }, discounts?: Array<{ __typename?: 'Discount', label: string, amount: { __typename?: 'Money', value?: number | null, currency?: Types.CurrencyEnum | null } } | null> | null, total_tax: { __typename?: 'Money', value?: number | null, currency?: Types.CurrencyEnum | null } } | null, items?: Array<{ __typename?: 'BundleOrderItem', product_name?: string | null, product_sku: string, quantity_ordered?: number | null, product_sale_price: { __typename?: 'Money', value?: number | null, currency?: Types.CurrencyEnum | null } } | { __typename?: 'DownloadableOrderItem', product_name?: string | null, product_sku: string, quantity_ordered?: number | null, product_sale_price: { __typename?: 'Money', value?: number | null, currency?: Types.CurrencyEnum | null } } | { __typename?: 'OrderItem', product_name?: string | null, product_sku: string, quantity_ordered?: number | null, product_sale_price: { __typename?: 'Money', value?: number | null, currency?: Types.CurrencyEnum | null } } | null> | null } | null> } | null } | null };


export const GetOrderDocument = gql`
    query getOrder($orderNumber: String!) {
  customer {
    orders(filter: {number: {eq: $orderNumber}}) {
      total_count
      items {
        id
        number
        order_date
        status
        shipping_method
        shipping_address {
          firstname
          lastname
          company
          street
          city
          region
          region_id
          postcode
          country_code
          telephone
        }
        billing_address {
          firstname
          lastname
          company
          street
          city
          region
          region_id
          postcode
          country_code
          telephone
        }
        total {
          grand_total {
            value
            currency
          }
          subtotal {
            value
            currency
          }
          total_shipping {
            value
            currency
          }
          discounts {
            amount {
              value
              currency
            }
            label
          }
          total_tax {
            value
            currency
          }
        }
        items {
          product_name
          product_sku
          product_sale_price {
            value
            currency
          }
          quantity_ordered
        }
      }
    }
  }
}
    `;

/**
 * __useGetOrderQuery__
 *
 * To run a query within a React component, call `useGetOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderQuery({
 *   variables: {
 *      orderNumber: // value for 'orderNumber'
 *   },
 * });
 */
export function useGetOrderQuery(baseOptions: Apollo.QueryHookOptions<GetOrderQuery, GetOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrderQuery, GetOrderQueryVariables>(GetOrderDocument, options);
      }
export function useGetOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrderQuery, GetOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrderQuery, GetOrderQueryVariables>(GetOrderDocument, options);
        }
export type GetOrderQueryHookResult = ReturnType<typeof useGetOrderQuery>;
export type GetOrderLazyQueryHookResult = ReturnType<typeof useGetOrderLazyQuery>;
export type GetOrderQueryResult = Apollo.QueryResult<GetOrderQuery, GetOrderQueryVariables>;